import React from 'react'
import Navbar from '../components/navigation/Navbar'

const CustomerLayout = ({children}) => {
  return (
    <div className="flex flex-col min-h-screen">
        <Navbar />
        <div className="flex-grow">
            {children}
        </div>
        {/* <Footer /> */}
    </div>
  )
}

export default CustomerLayout